import { call, put, takeLatest, select } from 'redux-saga/effects';
import { filter } from 'lodash';
import { unavailableSituationsLinksByConvertationStatus as hideLinks } from '../../constants/situationsCodeMapping';

import { getTopSituations } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData(action) {
  const appStore = yield select((state) => state.app);
  const isConvertation = yield appStore.user.getIn(['data', 'isConvertation']);
  const response = yield call(getTopSituations, action.payload);
  yield put(
    response.isOk
      ? requestSuccess(
          isConvertation
            ? filter(response.data, (situation) => !hideLinks[situation.code])
            : response.data,
        )
      : requestFailure(response.error),
  );
}

export default function* topSituationsSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
